import { fork, all } from 'redux-saga/effects';

import authSagas from '../auth/duck/operations';
import projectsSagas from '../projects/duck/operations';
import modelSagas from '../models/duck/operations';
import brainHealthSagas from '../brainHealth/duck/operations';
import healthcareSagas from '../healthcareFacility/duck/operations';
import citiesCommunitiesSagas from '../citiesCommunities/duck/operations';
import higherEdSagas from '../higherEd/duck/operations';

export default function* watch() {
  yield all([fork(authSagas), fork(projectsSagas), fork(modelSagas), fork(brainHealthSagas), fork(healthcareSagas), fork(citiesCommunitiesSagas), fork(higherEdSagas)]);
}
